import { container } from "tsyringe";
export class UseCaseGetLocationByCode {
    async handle(code) {
        const getLocationByCode = container.resolve("iGetLocationByCode");
        const location = await getLocationByCode.handle(code);
        return location;
    }
    async formatedd(code) {
        const getLocationByCode = container.resolve("iGetLocationByCode");
        const location = await getLocationByCode.formatedd(code);
        return location;
    }
}
